import Header from '../src/components/Header'
import Hero from '../src/components/Hero'
import Menu from '../src/components/Menu'
import Footer from '../src/components/Footer'
import Promo from '../src/components/Promo'
import DrinksMenu from '../src/components/DrinksMenu'
import Info from '../src/components/Info'
import AllergensTxt from '../src/components/AllergensTxt'
import React, { useState, useEffect,useRef } from 'react'
import { groqFetch } from './services/groqFetch'
import useScrollPosition from '@react-hook/window-scroll'

function App() {
  const scrollYProgress = useScrollPosition(60 /*fps*/)
    const ref = useRef(null)
    const [isEng, setIsEng] = useState(false)
    const [isFood, setIsFood] = useState(true)
    const [categories, setCategories] = useState(null)
    const [products, setProducts] = useState(null)
    const [selectedCat, setSelectedCat] = useState('')
    const [drinkCategories, setDrinkCategories] = useState(null)
    const [drinkProducts, setDrinkProducts] = useState(null)
    const [selectedDrinkCat, setSelectedDrinkCat] = useState('')
    const [showInfo, setShowInfo] = useState(false)
    const [showAllergens, setshowAllergens] = useState(false)
    const [highlights, setHighlights] = useState(null)
    const [info, setInfo] = useState(null)
    const [searchStarted, setSearchStarted] = useState(false);
    const [searchFoodObject, setSearchFoodObject] = useState('')
    const [searchDrinkObject, setSearchDrinkObject] = useState('')
    const [allergens, setAllergens] = useState(null)
    const [pdfMenuState, setPdfMenuState] = useState(null)
    const [hasPromo, setHasPromo] = useState(true);
    
    function setSearchFoodObjectHandler(val){
        setSearchFoodObject(val)
    }
    function setSearchDrinkObjectHandler(val){
      setSearchDrinkObject(val)
    }
   
    
    useEffect(() => {
     groqFetch().then((data)=>{
        
          let cats = []  
          let prods = []
          let drinkCats = []
          let drinkProds = []
          let info = []
          let highlights = []
          let fetchedAllergens = []
          let pdfMenu = []
       
          for(let x of data){
            if(x.type === 'category'){
              cats.push(x)
            }else if(x.type === 'product' || x.type === 'lunchMenuProduct' || x.type === 'specialMenu2Product'){
              prods.push(x)
            }else if(x.type === 'drinksCategory'){
              drinkCats.push(x)
            }else if(x.type === 'drinksProduct'){
              drinkProds.push(x)
            }else if(x.type === 'info'){
              
              info.push(x)
            }else if(x.type === 'highlights'){
              highlights.push(x)
            }else if(x.type === 'allergens'){
              fetchedAllergens.push(x)            
            }else if(x.type === 'pdfFile'){
           
              pdfMenu.push(x);
            }
          }
         
          cats = cats.sort((a,b) => a.importance - b.importance)
          drinkCats = drinkCats.sort((a,b)=> a.importance - b.importance)
         
          setCategories(cats)
          setDrinkCategories(drinkCats)
          setProducts(prods)
          setDrinkProducts(drinkProds)
          setInfo(info)
          setHighlights(highlights)
          if(cats[1]){
            setSelectedCat(cats[1].title)
          }
          if(drinkCats[1]){
            setSelectedDrinkCat(drinkCats[0].title)
          }
          
          setshowAllergens(false)
        
          if(fetchedAllergens[0]){
            setAllergens(fetchedAllergens[0].allergens_text)
          }
  
          if(pdfMenu.length > 0){
            setPdfMenuState(pdfMenu)
          }
          
        })},[])
    
    
    function isFoodSetter(bool){
      setIsFood(bool)
    }
    const handleRefClick = () => {      
      ref.current?.scrollIntoView({behavior: 'smooth'});
    };
    const handleShowInfoClick = () =>{
      if(showAllergens === true){
        setshowAllergens(!showAllergens)
      }
      setShowInfo(!showInfo)
    }
    function handleShowAllergensClick(){
      if(showInfo === true){
        setShowInfo(!showInfo)
      }
      setshowAllergens(!showAllergens)      
    }
    function handleSearch(){
      setSearchStarted(!searchStarted)
    }
    function handlePdfOpen(){
      window.location = pdfMenuState[0].pdfUrl;
    }
    function closePromoBanner(){
      setHasPromo(false);
    }
    function togglePromoBanner(){
      setHasPromo(!hasPromo)
    }
    
    

  return (
    <div className='relative overflow-hidden font-1 text-xl bg-backgroundOne '>
      <div ref={ref}></div>
      {info && <Header info={info} pdfMenuState={pdfMenuState} handlePdfOpen={handlePdfOpen}  isEng={isEng} setIsEng={setIsEng} handleShowInfoClick={handleShowInfoClick}   />   }
      {info && 
      <Info showAllergens={showAllergens}  handleShowAllergensClick={handleShowAllergensClick} isEng={isEng} info={info} showInfo={showInfo} />  
      }
      {showAllergens && <AllergensTxt allergens={allergens} handleShowAllergensClick={handleShowAllergensClick} showAllergens={showAllergens}></AllergensTxt>}
       <Hero isEng={isEng} highlights={highlights} isFood={isFood} handleSearch={handleSearch}
       searchDrinkObject={searchDrinkObject} setSearchDrinkObjectHandler={setSearchDrinkObjectHandler}
       setSearchFoodObjectHandler={setSearchFoodObjectHandler} searchFoodObject={searchFoodObject}
       />
       {/* <Promo hasPromo={hasPromo} togglePromoBanner={togglePromoBanner}></Promo> */}
       {isFood ? 
       <Menu closePromoBanner={closePromoBanner} searchStarted={searchStarted} info={info} handleSearch={handleSearch} isEng={isEng} isFood={isFood} categories={categories} products={products} searchFoodObject={searchFoodObject}
        setSearchFoodObjectHandler={setSearchFoodObjectHandler} 
       selectedCat={selectedCat} setSelectedCat={setSelectedCat} />
       : <DrinksMenu closePromoBanner={closePromoBanner}
       isEng={isEng} isFood={isFood} categories={drinkCategories}  searchDrinkObject={searchDrinkObject} searchStarted={searchStarted}
        setSearchDrinkObjectHandler={setSearchDrinkObjectHandler} handleSearch={handleSearch}
       products={drinkProducts} selectedCat={selectedDrinkCat} setSelectedCat={setSelectedDrinkCat} />}

      <Footer closePromoBanner={closePromoBanner}
      isEng={isEng} setIsEng={setIsEng} scrollYProgress={scrollYProgress}  handleShowInfoClick={handleShowInfoClick}
      handleRefClick={handleRefClick}  isFood={isFood} isFoodSetter={isFoodSetter} />
    </div>
  );
}

export default App;
